export default class PaymentRequest {
  constructor(payerData, paymentDetail, documents) {
    this.payer_data = payerData;
    this.payment_detail = paymentDetail;
    this.documents = documents;
  }
}
